module.exports = __webpack_public_path__ + "static/media/golf_course.3929abc4.svg";